// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  resize: none;
  width: 100%;
}

.form-check-inline {
  display: inline-block;
  margin-right: 10px;
}

.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.form-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.note {
  font-size: 12px;
}

.file-input {
  display: none;
}

.file-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.file-item small {
  margin-right: 10px;
}
.file-item button {
  margin-left: auto;
}

.search {
  border: none;
  background: none;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/enter-request/enter-request.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,qBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;AACN;AAEI;EACE,iBAAA;AAAN;;AAIE;EACE,YAAA;EACA,gBAAA;AADJ","sourcesContent":["textarea {\n    resize: none;\n    width: 100%;\n}\n\n.form-check-inline {\n    display: inline-block;\n    margin-right: 10px;\n}\n\n.my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.form-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.note {\n    font-size: 12px;\n}\n\n.file-input {\n    display: none;\n}\n\n.file-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n  \n    small {\n      margin-right: 10px;\n    }\n  \n    button {\n      margin-left: auto;\n    }\n  }\n\n  .search {\n    border: none;\n    background: none;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
